import AlertsApi from "../../../api/alerts-api";
import { AlertTypes } from "../../../constants/alert_types";
import moment from "moment-timezone";

// initial state
const initialState = () => ({
  isFetching: false,
  totals: {},
  technicalAlerts: [],
  earlierTechnicalAlerts: [],
  actualAlerts: [],
  earlierAlerts: [],
  lastHeats: []
});

// actions
const actions = {
  getAlerts: async ({ commit }, payload) => {
    const { totals_only, alert_types, alert_statuses, with_cow, with_building, limit, technicals, last_3_days } = payload || {};
    try {
      commit("request", payload);

      const apiResponse = await AlertsApi.get(
        { totals_only, alert_types, with_cow, with_building, limit, alert_statuses, last_3_days }
      );

      if (apiResponse && apiResponse.data) {
        if (totals_only) {
          commit("getTotalsOnlySuccess", { totals: apiResponse.data, technicals });
        } else {
          commit("getAlertsSuccess", { data: apiResponse.data, status: alert_statuses });
        }
      } else {
        commit("getAlertsFailed", apiResponse);
      }
    } catch (e) {
      commit("getAlertsFailed", e);
    }
  },

  getLastHeats: async ({ commit }) => {
    try {
      commit("request", {});
      const apiResponse = await AlertsApi.last_heats();

      if (apiResponse && apiResponse.data) {
        commit("getLastHeatsSuccess", { data: apiResponse.data, status: [] });
      } else {
        commit("getLastHeatsFailed", apiResponse);
      }
    } catch (e) {
      commit("getLastHeatsFailed", e);
    }
  },

  clear: ({ commit }) => {
    commit("clear", initialState());
  }
};

// mutations
const mutations = {
  request: (state, payload) => {
    state.isFetching = true;
    state.stateID = payload.stateID;
  },
  getTotalsOnlySuccess: (state, { totals, technicals }) => {
    state.isFetching = false;
    if (!totals)
      return [];
    if (technicals) {
      state.totals = { ...state.totals };
      [AlertTypes.LowCoverage, AlertTypes.OutOfRange, AlertTypes.NetworkFailure].forEach(type => {
        state.totals[type] = totals[type];
      })
    } else {
      Object.keys(totals).forEach((type) => {
        state.totals = { ...state.totals }
        if (![AlertTypes.LowCoverage, AlertTypes.OutOfRange, AlertTypes.NetworkFailure].includes(type))
          state.totals[type] = totals[type];
      })
    }
  },
  getAlertsSuccess: (state, { data, status }) => {
    state.isFetching = false;

    const alerts = data.filter(({ type }) =>
      ![AlertTypes.LowCoverage, AlertTypes.OutOfRange, AlertTypes.NetworkFailure].includes(type))
    const actualAlerts = alerts.filter(alert => alert.status === 'active');
    const earlierAlerts = alerts.filter(alert => alert.status !== 'active');

    function sort(data) {
      return [...data].sort((a, b) => {
        if (moment(a.alert_time).isBefore(moment(b.alert_time))) {
          return 1;
        }
        if (moment(b.alert_time).isBefore(moment(a.alert_time))) {
          return -1;
        }
        return 0;
      });
    }

    // Only update on status=active
    if (status.includes('active')) {
      state.actualAlerts = sort(actualAlerts)
      state.technicalAlerts = sort(data.filter(alert => [AlertTypes.LowCoverage, AlertTypes.OutOfRange, AlertTypes.NetworkFailure].includes(alert.type)));
    }

    // Only update on status!=active
    if (!status.includes('active')) {
      state.earlierAlerts = sort(earlierAlerts)
      state.earlierTechnicalAlerts = sort(data.filter(alert => [AlertTypes.LowCoverage, AlertTypes.OutOfRange, AlertTypes.NetworkFailure].includes(alert.type)));
    }
  },
  getAlertsFailed: state => {
    state.isFetching = false;
  },
  getLastHeatsSuccess: (state, { data }) => {
    state.lastHeats = data;
  },
  getLastHeatsFailed: () => {
  },
  clear: (state, initialState) => {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key];
    });
  }
};

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/plugins/store/modules/alerts.js